module.exports = __webpack_public_path__ + "media/customer_tickets/package-8e7d6ae1.svg";